import React from "react";
import io from "socket.io-client";

export const socket = io(process.env.REACT_APP_SOCKET_IO_SERVER);
console.log(process.env.REACT_APP_SOCKET_IO_SERVER);
const SocketContext = React.createContext(socket);
export default SocketContext;